import Faq from "./Faq";
import Form from "./Form";
import "../../shared/styles/index.css";

const College_Help_Section = () => {
  return (
    <div className="college-help-section-container">
      <Faq />
      <Form />
    </div>
  );
};

export default College_Help_Section;
